import innerQueryChartLineReducer from './queryChartReducer';
const initialState = {
    query: {
        query: [],
        response: {
            format: 'json-stat'
        }
    }
}
export default ( state = initialState, action) => {
    let query ={};
    switch(action.type){
        case 'SET_QUERY_VALUES_CHART_LINE':
            return {...state, query: action.payload};
        case 'SET_STATUS_CHECK_CHART_LINE':
        case 'SET_QUERY_ALL_VALUES_CHART_LINE':
             query = {...state.query, query: innerQueryChartLineReducer(state.query.query, action)}
            return {...state, query};
        default:
            return state;
    }
}

